<template>
  <material-card
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #subtitle>
      <div
        v-if="!$slots.subtitle"
        class="text-right text-h4 v-card__subtitle--material-stats"
        v-html="value"
      />
      <slot
        v-if="$slots.subtitle"
        name="subtitle"
      />
    </template>

    <template #actions>
      <slot name="actions" />
    </template>

    <slot />
  </material-card>
</template>

<script>
  export default {
    name: 'MaterialStatCard',

    props: { value: String },
  }
</script>

<style lang="sass">
.v-card__title .v-card--material__title
  padding-left: 0!important

.v-card--material-stats.v-card--material .v-card--material__title
  color: #999999
  font-size: .875rem !important
  margin-left: auto
  text-align: right

.v-card__subtitle--material-stats
  color: #3C4858
</style>
